{
  "formats": {
    "date": "{{date, date}}",
    "longDate": "{{longDate, longDate}}",
    "time": "{{time, time}}",
    "number": "{{number, number}}"
  }
}